import { render, staticRenderFns } from "./EntitiesView.vue?vue&type=template&id=c5a4bab2&"
import script from "./EntitiesView.vue?vue&type=script&lang=js&"
export * from "./EntitiesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EntitiesView.vue"
export default component.exports